import TitleBlockWrapper from '@anm/components/TitleBlock/Wrapper';
import Image from '@anm/components/image/Image';
import Dialog from '@anm/components/modals/Dialog';
import AlertBlock from '@anm/components/notification/AlertBlock';
import AlertBlockWrapper from '@anm/components/notification/AlertBlock/Wrapper';
import { flexCenter, flexColumn } from '@anm/styles/helpers';
import { FC } from 'react';
import styled from 'styled-components';

export const SuccessDialog = styled(Dialog)`
  width: 100%;
`;

const SuccessAlertWrapper = styled.div`
  ${flexColumn};
  ${flexCenter};
  ${AlertBlockWrapper} {
    max-width: 600px;
  }
  ${TitleBlockWrapper} {
    max-width: unset;
    margin-bottom: 23px;
  }
  img {
    width: 60px;
    height: 60px;
    margin-top: 16px;
    margin-bottom: 30px;
  }
`;

type SuccessAlertDialogProps = {
  message: string;
  onCloseAlert: () => void;
  onButtonClick: () => void;
};
const SuccessAlertDialog: FC<SuccessAlertDialogProps> = ({
  message,
  onCloseAlert,
  onButtonClick
}) => (
  <SuccessDialog onModalClose={onCloseAlert}>
    <SuccessAlertWrapper>
      <Image src="images/icons/pricing/success.svg" />
      <AlertBlock
        description={message}
        titleSize="extra-large"
        button={{
          text: 'Done',
          size: 'big',
          variant: 'light-blue-lowercase'
        }}
        onButtonClick={onButtonClick}
      ></AlertBlock>
    </SuccessAlertWrapper>
  </SuccessDialog>
);

export default SuccessAlertDialog;
